module.exports = "<h2><mat-icon style=\"vertical-align: middle\">error</mat-icon>&nbsp; {{loc.get('DialogNotFoundTitle')}}</h2>\n<p [innerHTML]=\"loc.get('DialogNotFoundBody')\"></p>\n<div style=\"margin-top: 10px; text-align: right\">\n  <button mat-raised-button (click)=\"closeDialog()\">{{loc.get('Chiudi')}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/not-found-dialog/not-found-dialog.html
// module id = ./src/app/dialogs/not-found-dialog/not-found-dialog.html
// module chunks = main